import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Records a warehouse-flagged problem against an order shipment (keyed by
 * fulfillment group) or a return (a return item or an inventory item).
 */
export const flagWarehouseProblem = {
  name: "flagWarehouseProblem" as const,
  input: z
    .object({
      target: z.discriminatedUnion("kind", [
        z.object({
          kind: z.literal("return"),
          returnId: zExt.objectId("returns"),
          returnItemId: zExt.objectId().optional(),
          inventoryItemId: inventoryItemIdFormat.schema.optional(),
        }),
        z.object({
          kind: z.literal("order"),
          fulfillmentGroupId: zExt.objectId(),
          /** Fulfillment line item externalId (globally unique) within the group. */
          fulfillmentLineItemId: z.string().optional(),
        }),
      ]),
      note: z.string().trim().min(1),
    })
    .refine(
      ({ target }) =>
        target.kind !== "return" ||
        !(target.returnItemId != null && target.inventoryItemId != null),
      {
        message: "Flag either a return item or an inventory item, not both",
        path: ["target", "inventoryItemId"],
      },
    ),
  output: z.object({ id: z.string() }),
};
